import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-6592">
      <div className="grid grid-cols-3 gap-3" data-id="element-6593">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-6594">
          <div className="text-2xl font-bold text-purple-700" data-id="element-6595">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-6596">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-6597">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-6598">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-6599">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-6600">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-6601">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-6602">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-6603">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6604">Docenten</h3>
          <div className="space-y-1" data-id="element-6605">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-6606">
                <Avatar name={t.name} data-id="element-6607" />
                <span className="text-sm text-gray-700" data-id="element-6608">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-6609">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6610">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-6611">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-6612">
                <div className="flex items-center gap-2" data-id="element-6613">
                  <Avatar name={learner.name} data-id="element-6614" />
                  <div data-id="element-6615">
                    <div className="text-sm text-gray-800" data-id="element-6616">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-6617">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-6618" />
              </div>)}
          </div>
        </div>}
    </div>;
}